import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, FormHelperText, Typography } from '@material-ui/core';
import useReactHookFormStyles from '../../../../custom-components/form-components/ReactHookForm.styles';
import Dropzone from './Dropzone';

const FileUpload = ({ name, props: { label, rules, required } }) => {
    const classes = useReactHookFormStyles();

    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <>
            <Typography className="my-8">{label}</Typography>
            <FormControl className={classes.formController}>
                <Controller
                    name={name}
                    control={control}
                    rules={rules}
                    render={({ field: { onChange, value } }) => {
                        return (
                            <Dropzone
                                handleDrop={async (file, e) => {
                                    if (!file || !file.length) {
                                        onChange(null);
                                        return;
                                    }
                                    onChange(file);
                                }}
                                name={name}
                                value={value}
                                required={required}
                            />
                        );
                    }}
                />
                {errors[name] && <FormHelperText>{errors[name]?.message}</FormHelperText>}
            </FormControl>
        </>
    );
};

export default React.memo(FileUpload);
